import { atom } from 'recoil'

export interface Breadcrumb {
  key: string
  label: JSX.Element | string
  active?: boolean
}

export const breadcrumbState = atom({
  key: 'breadcrumbs',
  default: [] as Breadcrumb[],
})
